import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import type { AppDispatch, RootState } from 'store';
import { PaginateSuppliersActions as PaginateActions } from 'store/ducks/suppliers';
import { usePaginationCache } from 'hooks';
import { Scaffold } from 'layouts';
import {
  SuppliersList,
  SupplierFilters,
  FindSuppliers,
} from 'components/Pages/Suppliers';
import { Paginator, ListingPageHeader, SettingsMenu } from 'components/Shared';
import * as S from './styles';

export const SuppliersListPage: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();

  const { paginationCache, updatePaginationCache, handleFilter, handleSort } =
    usePaginationCache('suppliers');

  const {
    data: suppliers,
    pagination,
    loading,
  } = useSelector((state: RootState) => state.paginateSuppliers);

  const [query, setQuery] = useState<FindSuppliers>({
    search: '',
    page: 1,
    limit: 10,
    ...paginationCache,
  });

  const onPageChange = useCallback((page: number): void => {
    setQuery((state) => ({ ...state, page }));
  }, []);

  const onQueryChange = useCallback((): void => {
    dispatch(PaginateActions.request(query));
  }, [dispatch, query]);

  useEffect(() => {
    onQueryChange();
  }, [onQueryChange]);

  useEffect(() => {
    return () => {
      dispatch(PaginateActions.reset());
      updatePaginationCache(query);
    };
  }, [dispatch, query, updatePaginationCache]);

  return (
    <Scaffold>
      <SettingsMenu />
      <S.MainPanel>
        <ListingPageHeader
          icon={<S.FactoryIcon />}
          title="Fornecedores"
          isLoading={loading}
          actions={
            <S.LinkButton to={'/configuracoes/fornecedores/criar'} size="small">
              <S.PlusIcon /> Novo fornecedor
            </S.LinkButton>
          }
        />
        <SupplierFilters
          currentFilter={query}
          onFilter={(filter) => handleFilter(query, filter, setQuery)}
        />
        <SuppliersList
          suppliers={suppliers}
          currentSort={query}
          onSort={(sort) => handleSort(query, sort, setQuery)}
        />
        <Paginator onPageChange={onPageChange} pagination={pagination} />
      </S.MainPanel>
    </Scaffold>
  );
};
